/** @format */

import {
    ORDER_STATUS_IN_CART,
    ORDER_STATUS_QUOTE_SAVED,
    ORDER_STATUS_BILLING_CUE,
    ORDER_STATUS_BILLING_IN_PROGRESS,
    ORDER_STATUS_NEEDS_ASSISTANCE,
    ORDER_STATUS_PREPRINTING_CUE,
    ORDER_STATUS_PREPRINTING_IN_PROGRESS,
    ORDER_STATUS_WAITING_ON_CUSTOMER,
    ORDER_STATUS_PREPRINTING_QC,
    ORDER_STATUS_PRINTING_CUE,
    ORDER_STATUS_PRINTING_IN_PROGRESS,
    ORDER_STATUS_LAMINATING_CUE,
    ORDER_STATUS_CONVERTING_CUE,
    ORDER_STATUS_CONVERTING_IN_PROGRESS,
    ORDER_STATUS_BLANKING_CUE,
    ORDER_STATUS_REWINDING_CUE,
    ORDER_STATUS_REWINDING_IN_PROGRESS,
    ORDER_STATUS_REWINDING_QC,
    ORDER_STATUS_SHIPPING_QC,
    ORDER_STATUS_SHIPPING_CUE,
    ORDER_STATUS_SHIPPING_IN_PROGRESS,
    ORDER_STATUS_COMPLETE,
    PROOF_STATUS_PENDING,
    PROOF_STATUS_APPROVED,
    PROOF_STATUS_DISAPPROVED,
    SIZE_STATUS_APPROVED,
    SIZE_STATUS_INSTOCK,
    SIZE_STATUS_ORDERED,
    SIZE_STATUS_PENDING,
    PRODUCT_TYPE_LABEL,
    PRODUCT_TYPE_CARTON,
    SHAPE_RECTANGLE,
    SHAPE_CIRCLE,
    SHAPE_SQUARE,
    SHAPE_OVAL,
    SHAPE_CUSTOM,
    SHAPE_CARTON_AUTOLOCK,
    SHAPE_CARTON_STRAIGHT_TUCK,
    PRODUCT_TYPE_GRAPHIC_DESIGN,
    SHAPE_CARTON_CUSTOM,
    INVOICE_STATUS_PENDING,
    INVOICE_STATUS_SUBMITTED,
    RECEIVING_STATUS_PENDING,
    RECEIVING_STATUS_CHECKEDIN,
    RECEIVING_STATUS_RECEIVED,
    SUPPLY_STATUS_UNUSED,
    SUPPLY_STATUS_USED,
    SUPPLY_STATUS_LOST,
    SUPPLY_STATUS_BAD,
    SUPPLY_STATUSES
} from 'frontier-constants';

export default (function () {
    // @see ManticoreClient parseTimeFilters
    const defaultIntervals = [
        {
            value: 'P25D',
            label: 'Last 25 Days'
        },
        {
            value: 'PT1M',
            label: 'Today'
        },
        {
            value: 'P1D',
            label: 'Yesterday'
        },
        {
            value: 'last-month',
            label: 'Last Month'
        },
        {
            value: 'this-month',
            label: 'This Month'
        }
    ];
    // @see ManticoreClient parseTimeFilters
    const futureIntervals = [
        {
            value: 'tommorow',
            label: 'Tommorow'
        },
        {
            value: 'next-week',
            label: 'Next Week'
        },
        {
            value: 'next-month',
            label: 'Next Month'
        }
    ];
    return {
        filter_order_id: {query: '@filter_order_id', name: 'Order Id', type: 'text'},
        filter_cart_id: {query: '@filter_cart_id', name: 'Invoice Id', type: 'text'},
        design_ids: {query: '@design_ids', name: 'Design Id', type: 'text'}, // Use with manticore_orders_index index
        filter_design_id: {query: '@filter_design_id', name: 'Design Id', type: 'text'}, // Use with Design index
        filter_size_id: {query: '@filter_size_id', name: 'Die Id', type: 'text'}, // Use with Design index
        filter_user_id: {query: '@filter_user_id', name: 'User Id', type: 'text'},

        filter_discount_code: {query: '@filter_discount_code', name: 'Discount Code', type: 'text'},
        filter_discount_user_id: {
            query: '@filter_discount_user_id',
            name: 'Discount User',
            type: 'text'
        },

        filter_discount_active_status: {
            query: '@filter_discount_active_status',
            name: 'Active Status',
            options: [
                {id: 1, sort: 1, name: 'Inactive'},
                {id: 2, sort: 2, name: 'Active'}
            ],
            type: 'select'
        },

        filter_is_multipage: {
            query: '@filter_is_multipage',
            name: 'Multipage',
            options: [
                {id: 1, sort: 1, name: 'Yes'},
                {id: 0, sort: 2, name: 'No'}
            ],
            type: 'select'
        },
        filter_is_split: {
            query: '@filter_is_split',
            name: 'Split',
            options: [
                {id: 1, sort: 1, name: 'Yes'},
                {id: 0, sort: 2, name: 'No'}
            ],
            type: 'select'
        },
        filter_is_deep_cut: {
            query: '@filter_is_deep_cut',
            name: 'Deep Cut',
            options: [
                {id: 1, sort: 1, name: 'Yes'},
                {id: 0, sort: 2, name: 'No'}
            ],
            type: 'select'
        },
        filter_is_blank: {
            query: '@filter_is_blank',
            name: 'Is Blank',
            options: [
                {id: 1, sort: 1, name: 'Yes'},
                {id: 0, sort: 2, name: 'No'}
            ],
            type: 'select'
        },

        filter_order_status_id: {
            query: '@filter_order_status_id',
            name: 'Order Status',
            options: [
                {id: ORDER_STATUS_IN_CART, sort: 100, name: 'In Cart'},
                {id: ORDER_STATUS_QUOTE_SAVED, sort: 200, name: 'Saved Quote'},
                {id: ORDER_STATUS_BILLING_CUE, sort: 1, name: 'Billing Cue'},
                {id: ORDER_STATUS_BILLING_IN_PROGRESS, sort: 2, name: 'Billing In Progress'},
                {id: ORDER_STATUS_NEEDS_ASSISTANCE, sort: 3, name: 'Needs Assistance'},
                {id: ORDER_STATUS_PREPRINTING_CUE, sort: 4, name: 'Preprinting Cue'},
                {
                    id: ORDER_STATUS_PREPRINTING_IN_PROGRESS,
                    sort: 5,
                    name: 'Preprinting In Progress'
                },
                {id: ORDER_STATUS_WAITING_ON_CUSTOMER, sort: 6, name: 'Waiting'},
                {id: ORDER_STATUS_PREPRINTING_QC, sort: 7, name: 'Preprinting Qc'},
                {id: ORDER_STATUS_PRINTING_CUE, sort: 8, name: 'Printing Queue'},
                {id: ORDER_STATUS_PRINTING_IN_PROGRESS, sort: 9, name: 'Printing In Progress'},
                {id: ORDER_STATUS_LAMINATING_CUE, sort: 10, name: 'Laminating Queue'},
                {id: ORDER_STATUS_CONVERTING_CUE, sort: 11, name: 'Converting Queue'},
                {id: ORDER_STATUS_CONVERTING_IN_PROGRESS, sort: 12, name: 'Converting In Progress'},
                {id: ORDER_STATUS_BLANKING_CUE, sort: 13, name: 'Blanking Queue'},
                {id: ORDER_STATUS_REWINDING_CUE, sort: 14, name: 'Rewinding Queue'},
                {id: ORDER_STATUS_REWINDING_IN_PROGRESS, sort: 15, name: 'Rewinding In Progress'},
                {id: ORDER_STATUS_REWINDING_QC, sort: 16, name: 'Rewinding Qc'},
                {id: ORDER_STATUS_SHIPPING_QC, sort: 17, name: 'Shipping Qc'},
                {id: ORDER_STATUS_SHIPPING_CUE, sort: 18, name: 'Shipping Queue'},
                {id: ORDER_STATUS_SHIPPING_IN_PROGRESS, sort: 19, name: 'Shipping In Progress'},
                {id: ORDER_STATUS_COMPLETE, sort: 20, name: 'Complete'}
            ],
            type: 'select'
        },
        created: {
            query: '@created',
            name: 'Created',
            type: 'date_range',
            intervals: [...defaultIntervals]
        },
        // @see ManticoreClient parseTimeFilters
        expected_delivery_date: {
            query: '@expected_delivery_date',
            name: 'Expected Delivery Date',
            type: 'date_range',
            intervals: [...defaultIntervals, ...futureIntervals]
        },
        // @see ManticoreClient parseTimeFilters
        order_date: {
            query: '@order_date',
            name: 'Order Date',
            type: 'date_range',
            intervals: [...defaultIntervals]
        },
        // @see ManticoreClient parseTimeFilters
        receiving_date: {
            query: '@receiving_date',
            name: 'Received Date',
            type: 'date_range',
            intervals: [...defaultIntervals]
        },

        filter_proof_status_id: {
            query: '@filter_proof_status_id',
            name: 'Proof Status',
            options: [
                {id: PROOF_STATUS_PENDING, sort: 1, name: 'Pending'},
                {id: PROOF_STATUS_APPROVED, sort: 2, name: 'Approved'},
                {id: PROOF_STATUS_DISAPPROVED, sort: 3, name: 'Disapproved'}
            ],
            type: 'select'
        },
        filter_charge_status_id: {
            query: '@filter_charge_status_id',
            name: 'Charge Status',
            options: [
                {id: 2, sort: 2, name: 'Pending'},
                {id: 1, sort: 1, name: 'Complete'}
            ],
            type: 'select'
        },
        filter_shape_id: {
            query: '@filter_shape_id',
            name: 'Shape',
            options: [
                {id: SHAPE_RECTANGLE, sort: 1, name: 'Rectangle'},
                {id: SHAPE_CIRCLE, sort: 2, name: 'Circle'},
                {id: SHAPE_SQUARE, sort: 3, name: 'Square'},
                {id: SHAPE_OVAL, sort: 4, name: 'Oval'},
                {id: SHAPE_CUSTOM, sort: 5, name: 'Custom'},
                {id: SHAPE_CARTON_AUTOLOCK, sort: 6, name: 'Auto Lock'},
                {id: SHAPE_CARTON_STRAIGHT_TUCK, sort: 7, name: 'Straight Tuck'},
                {id: SHAPE_CARTON_CUSTOM, sort: 8, name: 'Custom Carton'}
            ],
            type: 'select'
        },
        filter_transaction_type_id: {
            query: '@filter_transaction_type_id',
            name: 'Type',
            options: [
                {id: 1, sort: 1, name: 'Cart'},
                {id: 2, sort: 2, name: 'Charge'}
            ],
            type: 'select'
        },
        filter_transaction_status_id: {
            query: '@filter_transaction_status_id',
            name: 'Status',
            options: [
                {id: 100, sort: 1, name: 'Pending'},
                {id: 200, sort: 2, name: 'Synced'},
                {id: 500, sort: 3, name: 'Error'}
            ],
            type: 'select'
        },
        filter_size_status_id: {
            query: '@filter_size_status_id',
            name: 'Die Status',
            options: [
                {id: SIZE_STATUS_APPROVED, sort: 1, name: 'Approved'},
                {id: SIZE_STATUS_INSTOCK, sort: 2, name: 'In-Stock'},
                {id: SIZE_STATUS_ORDERED, sort: 3, name: 'Ordered'},
                {id: SIZE_STATUS_PENDING, sort: 4, name: 'Pending'}
            ],
            type: 'select'
        },
        filter_product_type_id: {
            query: '@filter_product_type_id',
            name: 'Product Type',
            options: [
                {id: PRODUCT_TYPE_LABEL, sort: 1, name: 'Labels'},
                {id: PRODUCT_TYPE_CARTON, sort: 2, name: 'Carton'},
                {id: PRODUCT_TYPE_GRAPHIC_DESIGN, sort: 3, name: 'Design'}
            ],
            type: 'select'
        },
        filter_new_reorder: {
            query: '@filter_new_reorder',
            name: 'New/Reorder',
            options: [
                {id: 1, sort: 1, name: 'New Orders'},
                {id: 2, sort: 2, name: 'Reorders'}
            ],
            type: 'select'
        },
        filter_processing_id: {
            query: '@filter_processing_id',
            name: 'Processing',
            options: [
                {id: 1, sort: 1, name: 'Standard Processing'},
                {id: 2, sort: 2, name: 'Expedited'}
            ],
            type: 'select'
        },
        filter_charge_type_id: {
            query: '@filter_charge_type_id',
            name: 'Charge Type',
            options: [
                {id: 1, sort: 1, name: 'Charge'},
                {id: 2, sort: 2, name: 'Refund'}
            ],
            type: 'select'
        },
        filter_new_size: {
            query: '@filter_new_size',
            name: 'New Size',
            options: [
                {id: 1, sort: 1, name: 'Yes'},
                {id: 2, sort: 2, name: 'No'}
            ],
            type: 'select'
        },
        filter_has_pantones: {
            query: '@filter_has_pantones',
            name: 'Has Pantones',
            options: [
                {id: 1, sort: 1, name: 'Yes'},
                {id: 2, sort: 2, name: 'No'}
            ],
            type: 'select'
        },
        filter_has_variable_data: {
            query: '@filter_has_variable_data',
            name: 'Has Variable Data',
            options: [
                {id: 1, sort: 1, name: 'Yes'},
                {id: 2, sort: 2, name: 'No'}
            ],
            type: 'select'
        },
        size_comments: {query: '@size_comments', name: 'Comments', type: 'text'},
        filter_width: {query: '@filter_string_width', name: 'Width', type: 'text'},
        filter_length: {query: '@filter_string_length', name: 'Length', type: 'text'},
        filter_depth: {query: '@filter_string_depth', name: 'Depth', type: 'text'},
        po_number: {query: '@po_number', name: 'PO Number', type: 'text'},
        filter_purchase_order_status_id: {
            query: '@filter_status_id',
            name: 'Received Status',
            options: [
                {id: RECEIVING_STATUS_PENDING, sort: 1, name: 'Pending'},
                {id: RECEIVING_STATUS_RECEIVED, sort: 2, name: 'Received'},
                {id: RECEIVING_STATUS_CHECKEDIN, sort: 3, name: 'Checked-In'}
            ],
            type: 'select'
        },
        filter_supply_status_id: {
            query: '@filter_status_id',
            name: 'Supply Status',
            options: SUPPLY_STATUSES.map(status => {
                status.name = status.label;
                return status;
            }),
            type: 'select'
        },
        filter_invoice_status_id: {
            query: '@filter_invoice_status_id',
            name: 'Invoice Status',
            type: 'select',
            options: [
                {id: INVOICE_STATUS_PENDING, sort: 1, name: 'Pending'},
                {id: INVOICE_STATUS_SUBMITTED, sort: 2, name: 'Submitted'}
            ]
        },
        filter_vendor_label: {
            query: '@vendor_label',
            name: 'Vendor',
            type: 'text'
        },
        filter_sku_label: {
            query: '@sku_label',
            name: 'Sku',
            type: 'text'
        }
    };
});
